import $ from 'jquery'

export default function gambi1() {
  $('.video-historia, .single, .cada-video').find('iframe').removeAttr('height').removeAttr('width')
}